import { useMemo } from 'react'

import calc from 'pared/Routes/renderer/utils/calc'

import useLabor from '../common/useLabor'

const useMonthlyLabor = () => {
  const { data, loading } = useLabor()

  return {
    data: useMemo(() => {
      if (!data) return null

      return {
        ...data,
        total: calc(data.total, '/', 12),
      }
    }, [data]),
    loading,
  }
}

export default useMonthlyLabor
